import { DashboardZones } from "@/entities/api/users/users"

interface RoutesInterface {
	name: string
	value?: DashboardZones
	path: string
	icon: string
}

export const dashboardRoutes: RoutesInterface[] = [
	{ name: 'Dashboard', path: '/', icon: 'house' },
	{
		name: 'Pedidos',
		value: DashboardZones.orders,
		path: '/orders',
		icon: 'shopping',
	},
	{
		name: 'Ventas',
		value: DashboardZones.orders,
		path: '/sales',
		icon: 'dollar',
	},
	{
		name: 'Inventario',
		value: DashboardZones.inventary,
		path: '/stock',
		icon: 'box',
	},
	{
		name: 'Usuarios',
		value: DashboardZones.users,
		path: '/users',
		icon: 'user',
	},
	{
		name: 'Clientes',
		value: DashboardZones.customers,
		path: '/customers',
		icon: 'users',
	},
	{
		name: 'Categorias',
		value: DashboardZones.categories,
		path: '/categories',
		icon: 'category',
	},
	{
		name: 'Cupones',
		value: DashboardZones.coupons,
		path: '/coupons',
		icon: 'ticket',
	},
	{
		name: 'Solicitudes',
		value: DashboardZones.contact,
		path: '/users-request',
		icon: 'email',
	},
]
